import * as React from "react";
import { Tag } from "antd";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";

interface TaskStateTagProps extends WithTranslation {
  state: API_SUBTASKDATA_STATE;
}

export const TaskStateTag = withTranslation(I18N_NS.PROJECT)(
  class extends React.Component<TaskStateTagProps, {}> {
    public render() {
      return this.renderState(this.props.state);
    }

    private renderState = (state: API_SUBTASKDATA_STATE) => {
      let parsedState: string, color: string;
      switch (state) {
        case "OPEN":
          parsedState = "Open";
          color = null;
          break;
        case "IN_PROGRESS":
          parsedState = "In Progress";
          color = "blue";
          break;
        case "WAITING":
          parsedState = "Waiting";
          color = "orange";
          break;
        case "FINISHED":
          parsedState = "Done";
          color = "green";
          break;
        case "CANCELED":
          parsedState = "Cancelled";
          color = "red";
          break;
        default:
          parsedState = "";
          color = null;
          break;
      }
      if (!parsedState) {
        return null;
      }
      return (
        <Tag
          style={{ cursor: "default" }}
          color={color}
          data-testid={`task-state-tag-${state.toLowerCase().replace("_", "-")}`}
        >
          {this.props.t(parsedState)}
        </Tag>
      );
    };
  }
);
